import { HIVE_DOC_REMOTE_SELECTION_WIDGET } from './doc';
import { HiveDocRemoteSelectionWidget } from './doc/doc-remote-selection';
import {
  HIVE_EDGELESS_REMOTE_SELECTION_WIDGET,
  EdgelessRemoteSelectionWidget,
} from './edgeless';

export function effects() {
  customElements.define(
    HIVE_DOC_REMOTE_SELECTION_WIDGET,
    HiveDocRemoteSelectionWidget
  );
  customElements.define(
    HIVE_EDGELESS_REMOTE_SELECTION_WIDGET,
    EdgelessRemoteSelectionWidget
  );
}
